import {useLayoutEffect, useState } from 'react';

const useIsDesktop = () => {
  const [size, setSize] = useState(window.innerWidth)

  const handleSize = () => {
    setSize(window.innerWidth);
  };

  useLayoutEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize)
    return ()=> window.removeEventListener("resize", handleSize)
  }, [])
  return Boolean(size > 1023);
}
export default useIsDesktop;